import { getNetwork } from '../utils/getNetwork';
import { API_ROOT, API_AUTH } from '../config';

export const fetchReportNames = () => getNetwork().get(`${API_ROOT}/edu-report/kind`);
export const fetchDistricts = () => getNetwork().get(`${API_AUTH}/get/regions`);
export const fetchLocalities = () => getNetwork().get(`${API_AUTH}/get/locality`);
export const fetchLocalitiesByRegion = (regionId) =>
  getNetwork().get(`${API_AUTH}/get/locality/${regionId}`);
export const fetchOrganizations = () => getNetwork().get(`${API_AUTH}/get/organization`);
export const fetchYears = () => getNetwork().get(`${API_ROOT}/edu-report/year`);
export const fetchMonths = () => getNetwork().get(`${API_ROOT}/edu-report/month`);